<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Edit',
                link: {
                    name: 'Job Stack Deployment Pipeline Edit',
                    params: { sandboxId: `${selectedSandbox}`, id: `${$route.params.id}` },
                },
            },
            {
                name: 'Pipeline',
                link: {
                    name: 'Job Stack Deployment Details Pipeline',
                    params: { sandboxId: `${selectedSandbox}`, id: `${$route.params.id}` },
                },
            },
            {
                name: 'Visualize',
                link: {
                    name: 'Job Stack Deployment Details Visualize',
                    params: { sandboxId: `${selectedSandbox}`, id: `${$route.params.id}` },
                },
            },
        ]" pretitle="aqfer Graph Manager" :breadcrumbTitle=true @nav-close-clicked="closeNav">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a @click="closeClick" href="#" class="h1">Deployments</a></li>
                        <li class="breadcrumb-item active h1" aria-current="page">{{ $route.params.id }}</li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <div class="custom-btn-group">
                    <div v-if="editMode">
                        <button v-if="showEditButton" class="btn btn-success" @click.prevent="onSaveclick"
                            :disabled="saving">
                            <div v-if="saving" class="spinner-border spinner-border-sm me-1" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Save
                        </button>
                        <button v-if="showEditButton" class="btn btn-success" @click.prevent="onSaveAndRunCLick"
                            :disabled="saving">
                            <div v-if="saving" class="spinner-border spinner-border-sm me-1" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Save & Run
                            <span v-if="saveAndRunStatus?.save_and_run_tooltip" class="ms-1">
                                <i class="fa fa-circle-exclamation text-warning" data-bs-toggle="tooltip"
                                    data-bs-placement="bottom" :title="saveAndRunStatus.save_and_run_tooltip" @click.stop></i>
                            </span>
                        </button>
                        <button v-if="showEditButton" class="btn btn-secondary" @click.prevent="onCancelClick"
                            :disabled="saving">
                            <div>
                                <slot></slot>Cancel
                            </div>
                        </button>
                    </div>
                    <div v-else>
                        <button v-if="showEditButton" class="btn btn-warning" @click.prevent="onEditClick">
                            <div>
                                <slot></slot>Edit
                            </div>
                        </button>
                    </div>
                    <button v-if="showRunAllButton == 'pipeline' || (showRunAllButton == 'edit' && pipelineJob && !editMode)" class="btn btn-info" @click.prevent="onRunAllClick" :disabled="running">
                        <div v-if="running">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <span v-if="pipelineExecutionDetails?.status == 'RUNNING'" class="ms-1">
                                Running
                            </span>
                        </div>
                        <div v-else>
                            <i class="fa fa-play me-1"></i>
                            Run
                            <span class="ms-1">
                                <i class="fa fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="bottom"
                                    title="Run all jobs in this deployment" @click.stop></i>
                            </span>
                        </div>
                    </button>
                    <button v-if="showPromoteButton && !editMode" class="btn btn-primary flex"
                        @click.prevent="onPromoteClick"
                        :disabled="promoting || !jobDetails || Object.keys(jobDetails).length === 0 || (promotionStatus && promotionStatus.promotion_enabled === false)">
                        <div v-if="promoting == 'promoting'" class="spinner-border spinner-border-sm me-1"
                            role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Promote
                        <span v-if="promotionStatus?.promotion_tooltip" class="ms-1">
                            <i :class="promotionStatus.promotion_tooltip_icon_class || 'fa fa-circle-exclamation text-warning'"
                                data-bs-toggle="tooltip" data-bs-placement="bottom"
                                :title="promotionStatus.promotion_tooltip" @click.stop></i>
                        </span>
                    </button>
                    <button v-if="showVisualizationButton" class="btn btn-primary flex"
                        @click.prevent="visualize(true)"
                        :disabled="loading || queryRunning || !fetchVisualizationTrigger">
                        <div v-if="queryRunning" class="spinner-border spinner-border-sm me-1"
                            role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Visualize
                        <span v-if="promotionStatus?.promotion_tooltip" class="ms-1">
                            <i class="fa fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="bottom"
                                    title="Visualize data from the pipeline" @click.stop></i>
                        </span>
                    </button>
                    <button @click="closeClick" class="btn btn-secondary lift">
                        <i class="fa fa-arrow-left me-1"></i> Back to Deployments list
                    </button>
                </div>
            </template>
        </nav-header>
        <div>
            <router-view :deployment="deployment" :jobNames="jobNames" :editMode="editMode" :loading="loading"
                :promoting="promoting" :jobs="jobDetails" :saveTrigger="saveTrigger" :fetchVisualizationTrigger="fetchVisualizationTrigger"
                :pipelineExecutionDetails="pipelineExecutionDetails" :saveAndRunTrigger="saveAndRunTrigger"
                :destinationSandbox="destinationSandbox" :queryRunning="queryRunning" :queryId="queryId" :outputData="outputData" :outputColumns="outputColumns"
                :isPartialResult="isPartialResult" :visualizationError="visualizationError"
                v-on:onPromoteClick="onPromoteClick" v-on:refreshJobsDetails="fetchJobDetails" v-on:setRunAllButton="setRunAllButton"
                v-on:setEditButton="setEditButton" v-on:setEditMode="setEditMode" v-on:saving="showSaving"
                v-on:setPromoteButton="setPromoteButton" v-on:triggerPipelineStatusCheck="triggerPipelineStatusCheck"
                v-on:destinationSandboxChange="setDestinationSandbox" v-on:visualizeTrigger="visualize()" v-on:setVisualizationButton="setVisualizationButton">
            </router-view>
        </div>
    </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
import { DateTimeFormat } from '../../utils/commonFunction';
import axios from 'axios';
import { tooltips } from "@codemirror/view";
export default {
    name: "Job Stack Deployment Details",
    components: { NavHeader },
    data() {
        return {
            selectedSandbox: this.$route.params.sandboxId,

            loading: false,
            saving: false,
            running: false,
            promoting: '',
            editMode: false,
            saveTrigger: false,
            saveAndRunTrigger: false,
            saveAndRunStatus: null,
            promotionStatus: null,

            deployment: null,
            jobDetails: {}, // Store the job details here
            pipelineExecutionDetails: {}, // Store the pipeline execution details here

            promotions: {},
            destinationSandbox: "idr-edge-extract",

            showRunAllButton: "",
            showEditButton: false,
            showPromoteButton: false,
            breakCheck: false,

            fetchVisualizationTrigger: false,
            showVisualizationButton: false,
            queryName: '',
            queryRunning: false,
            queryId: null,
            isPartialResult: false,
            outputData: null,
            outputColumns: [],
            visualizationError: null,
            breakCheckVisualization: false,
        };
    },
    async beforeMount() {
        await this.fetchDeployment();
        await this.fetchJobDetails();
        const executionId = await this.getLatestExecutionId();
        await this.trackPipelineExecutionStatus(executionId);
    },
    beforeUnmount() {
        this.breakCheck = true;
        this.breakCheckVisualization = true;
    },
    computed: {
        jobNames() {
            if (this.deployment?.jobs) {
                try {
                    return this.deployment.jobs.map(job => job.name);
                } catch (e) {
                    return [];
                }
            }
            return []
        },
        pipelineJob() {
            if (!this.jobDetails) return null;
            return Object.values(this.jobDetails).find(job => job.kind?.toLowerCase() === 'pipeline');
        },
    },
    methods: {
        ...mapActions({
            readDeployment: "amdp/readJobStackDeployment",
            readJob: 'amdp/readJob',
        }),
        DateTimeFormat,
        async fetchDeployment() {
            this.loading = true;
            try {
                const response = await this.readDeployment({
                    sandboxName: this.$route.params.sandboxId,
                    deploymentId: this.$route.params.id
                });
                this.deployment = response.data;
            } catch (error) {
                console.error("Error fetching job stack deployments: ", error);
                let err = error.response?.data?.error ? error.response.data.error : error.message;
                this.$store.dispatch("addToast", {
                    message: err || "Something went wrong when fetching job stack deployment. Please contact support.",
                    type: "error",
                });
            } finally {
                this.loading = false;
            }
        },
        async fetchJobDetails() {
            if (!this.jobNames || this.jobNames.length === 0) {
                console.log('No jobs found in the deployment');
                this.jobDetails = {};
                return;
            }

            this.loading = true;
            try {
                const details = await Promise.all(
                    this.jobNames.map(async (jobName) => {
                        const response = await this.readSandboxJobDetails(this.deployment.sandbox, jobName);
                        this.jobDetails[jobName] = response?.data;
                    })
                );
                this.jobDetails = JSON.parse(JSON.stringify(this.jobDetails));
            } catch (error) {
                console.error('Error fetching pipeline details:', error);
            } finally {
                this.loading = false;
                await this.promoteRequiredJobs(true); // to trigger promotion status inspection
            }
        },
        async readSandboxJobDetails(sandboxName, jobName) {
            return axios.get(this.$store.state.lakeviewUrl + `/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${sandboxName}/jobs/${jobName}`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            })
        },
        closeClick() {
            this.$router.push({
                name: "Job Stack Deployments List",
                params: {
                    sandboxId: `${this.$route.params.sandboxId}`,
                },
            });
        },
        async getLatestExecutionId() {
            if (!this.pipelineJob?.name || !this.deployment?.sandbox) {
                console.log('No pipeline job or sandbox found..');
                return;
            }
            let executionId;
            await axios.get(`${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${this.deployment.sandbox}/jobs/${this.pipelineJob.name}/executions?limit=1`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            }).then((response) => {
                if (response?.data?.length > 0 && response.data[0]?.execution_id) {
                    executionId = response.data[0].execution_id;
                }
            }).catch((error) => {
                console.error('Error fetching latest running execution id: ', error);
            });
            return executionId || "";
        },
        async trackPipelineExecutionStatus(executionId) {
            if (!executionId) {
                console.error('No running execution id found to track pipeline execution status...');
                return;
            }

            this.running = true;
            this.pipelineExecutionDetails = {};
            const jobName = this.pipelineJob?.name;
            const sandboxName = this.deployment?.sandbox;
            const cid = this.$store.state.currentClient?.cid;

            // this loop is to wait till the execution starts running    
            let retryCount = 25;
            try {
                while (retryCount > 0) {
                    const response = await axios.get(
                        `${this.$store.state.lakeviewUrl}/v1/cids/${cid}/sandboxes/${sandboxName}/jobs/${jobName}/executions/${executionId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${this.$store.state.accessToken}`,
                            },
                        }
                    );
                    if (response.data?.status != 'SUBMITTED') {
                        break;
                    }
                    await new Promise(resolve => setTimeout(resolve, 5000)); // wait for 5 seconds
                    retryCount--;
                }
            } catch (error) {
                console.error('Error fetching pipeline job execution status: ', error);
            }

            try {
                // infinite loop until the component is unmounted or the pipeline is not running
                while (!this.breakCheck) {
                    let error = null;
                    let response;
                    let details = {
                        executionDetails: {},
                        executionDetailsByName: {}, // Also maintain a name-keyed bucket (used by in_loop display nodes)
                    };
                    try {
                        response = await this.getPipelineExecutionDetails(sandboxName, jobName, executionId);
                    } catch (e) {
                        error = e.response?.data?.error || e.message;
                        console.error('Error fetching pipeline execution details: ', error);
                    }
                    if (error) break;

                    // parse the response
                    response.data?.tasks?.forEach(task => {
                        const jobName = task.full_path.split('/').pop();
                        // Key by full_path for exact lookup (handles same job name in multiple positions)
                        details.executionDetails[task.full_path] = [task];

                        if (!details.executionDetailsByName[jobName]) details.executionDetailsByName[jobName] = [];
                        details.executionDetailsByName[jobName].push(task);
                    });
                    details = { ...details, ...response.data };
                    this.pipelineExecutionDetails = JSON.parse(JSON.stringify(details));

                    // stop if pipeline is not running
                    if (response.data?.status != 'RUNNING') break;
                    await new Promise(resolve => setTimeout(resolve, 5000)); // wait for 5 seconds
                }
            } catch (error) {
                console.error('Error fetching pipeline execution status: ', error);
            } finally {
                this.running = false;
            }
        },
        async getPipelineExecutionDetails(sandboxName, jobName, executionId) {
            return axios.get(
                `${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${sandboxName}/pipelines/${jobName}/executions/${executionId}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.$store.state.accessToken}`,
                    },
                }
            ).catch((error) => {
                throw error;
            });
        },
        async onRunAllClick() {
            if (!this.pipelineJob) {
                console.log('No pipeline job found..');
                return;
            }

            this.running = true;
            try {
                const cid = this.$store.state.currentClient?.cid;
                const sandboxName = this.deployment?.sandbox;
                const jobName = this.pipelineJob?.name; // pipeline job name
                const response = await axios.post(
                    `${this.$store.state.lakeviewUrl}/v1/cids/${cid}/sandboxes/${sandboxName}/jobs/${jobName}/executions`, {},
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.state.accessToken}`,
                        },
                    }
                );

                this.$store.dispatch("addToast", {
                    message: "Pipeline execution started successfully.",
                    type: "success",
                });

                // redirect to pipeline page if not already on it
                if (this.$route.name !== "Job Stack Deployment Details Pipeline") {
                    this.$router.push({
                        name: "Job Stack Deployment Details Pipeline",
                        params: {
                            sandboxId: `${this.$route.params.sandboxId}`,
                        },
                    });
                }
                // fetch the job execution status till the pipeline job is running
                await this.trackPipelineExecutionStatus(response?.data?.execution_id);
            } catch (error) {
                console.error('Error executing pipeline job:', error);
                this.$store.dispatch("addToast", {
                    message: error.response?.data?.error || error.message || "Failed to execute pipeline. Please contact support.",
                    type: "error",
                });
            } finally {
                this.running = false;
            }
        },


        // promotion functions
        async initializePromotions() {
            if (!this.jobDetails || Object.keys(this.jobDetails).length === 0) {
                console.log('No jobs to initialize promotion...');
                return;
            }

            // Process all jobs in parallel using Promise.all
            await Promise.all(
                Object.values(this.jobDetails).map(async (job) => {
                    const promoteObject = {
                        dst_sandbox_name: this.destinationSandbox,
                        dst_job_name: job.name,
                        description: `Promote - '${job.name}'`,
                        src_job_run_id: "",
                        vars: job?.system_files?.find(file => file.relative_path === 'vars.yaml')?.content || "",
                        meters: [],
                    }

                    let executions = await this.getLatestSuccessfulExecution(job.name);
                    if (Array.isArray(executions) && executions.length > 0) {
                        promoteObject.src_job_run_id = executions[0].id;
                        if (job.kind?.toLowerCase() === 'pipeline') {
                            this.fetchVisualizationTrigger = true;
                        }
                    }

                    this.promotions[job.name] = JSON.parse(JSON.stringify(promoteObject));
                })
            );
        },
        async getLatestSuccessfulExecution(jobName) {
            let sandbox = this.deployment.sandbox
            let response = await axios.get(`${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${sandbox}/jobs/${jobName}/executions?status=SUCCEEDED&limit=1`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            })
            return response.data?.length > 0 ? response.data : [];
        },
        preparePromotionPayload(jobName) {
            if (!this.promotions[jobName]) {
                return null;
            }
            const promotion = JSON.parse(JSON.stringify(this.promotions[jobName]));

            // Remove empty vars (Codemirror adds empty string on initial editor load)
            if (promotion.vars === '') {
                delete promotion.vars;
            }

            // Handle meters - add meters if not detach_meters and meters exist
            const meters = promotion.meters || [];
            if (!promotion.detach_meters && meters.length > 0) {
                promotion.meters = meters;
            } else {
                delete promotion.meters;
            }

            return promotion;
        },
        async getJobExecutionConfig(sandbox, job, jobRunId) {
            let responseObj = {
                jobName: job,
                config: null,
                error: null,
            }
            await axios.get(`${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${sandbox}/jobs/${job}/executions/${jobRunId}/configs`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            })
                .then((response) => {
                    responseObj.config = response.data || null;
                })
                .catch((error) => {
                    console.error(error);
                    responseObj.error = error;
                });
            return responseObj;
        },
        async promoteRequiredJobs(checkOnly = false) {
            try {
                if (!checkOnly && !this.$store.state.sandbox.prodV2Sandboxes.some(sandbox => sandbox.name === this.destinationSandbox)) {
                    console.error(`The selected destination sandbox ${this.destinationSandbox} is not available.`);
                    this.$store.dispatch("addToast", {
                        message: 'Failed to raise promotion requests. Please contact support.',
                        type: "warning",
                    });
                    return;
                }

                if (checkOnly) {
                    this.promotionStatus = null;
                    this.saveAndRunStatus = null;
                }
                this.promoting = checkOnly ? 'checking' : 'promoting';

                // initialize promotion object
                await this.initializePromotions();

                // for all jobs, promote only if there is a successful execution and if it is not updated in prod sandbox job or prod sandbox job not found
                let jobsWithoutExecution = []; // jobs without successful execution
                let jobsWithoutExecutionConfig = []; // jobs with successful execution but unable to get execution config
                let currentJobConfigs = {}; // current job configs (key is jobId, value is config). Need this to compare with prod sandbox job config.
                let prodJobConfigs = {}; // production sandbox job configs (key is jobId, value is config). Need this to compare with current sandbox job config.
                let totalPromotions = 0;
                const checkCurrentJobConfigPromises = Object.entries(this.promotions).map(async ([jobName, promotion]) => {
                    let currentSandboxId = this.deployment.sandbox;
                    let latestRunId = promotion.src_job_run_id;
                    if (!latestRunId) {
                        throw new Error(`No successful execution found for job - ${jobName}`);
                    }
                    let response = await this.getJobExecutionConfig(currentSandboxId, jobName, latestRunId);
                    if (response.error || !response.config) {
                        throw new Error(`No execution config found for job - ${jobName}`);
                    }
                    return response;
                })
                const results1 = await Promise.allSettled(checkCurrentJobConfigPromises);

                for (const result of results1) {
                    if (result.status === 'fulfilled') {
                        currentJobConfigs[result.value.jobName] = result.value.config;
                    } else {
                        let err = result.reason.message;
                        if (err.includes("No successful execution found for job")) {
                            let job = err.split("-")[1].trim();
                            jobsWithoutExecution.push(job);
                        } else if (err.includes("No execution config found for job")) {
                            let job = err.split("-")[1].trim();
                            jobsWithoutExecutionConfig.push(job);
                        }
                    }
                }

                if (jobsWithoutExecution.length > 0 || jobsWithoutExecutionConfig.length > 0) {
                    if (checkOnly) {
                        this.promotionStatus = JSON.parse(JSON.stringify({
                            promotion_enabled: false,
                            promotion_tooltip: 'No execution found for the pipeline.',
                            promotion_tooltip_icon_class: 'fa fa-circle-exclamation text-warning',
                        }));
                        return;
                    }
                    if (jobsWithoutExecution.length > 0) {
                        console.error(`Following jobs do not have successful executions - ${jobsWithoutExecution.join(', ')}.\nClick 'Run' and try promoting again.`);
                    }
                    if (jobsWithoutExecutionConfig.length > 0) {
                        console.error(`Execution config not found for the following jobs - ${jobsWithoutExecutionConfig.join(', ')}.\nClick 'Run' and try promoting again.`);
                    }
                    this.$store.dispatch("addToast", {
                        message: 'No execution found for the pipeline.',
                        type: "error",
                    });
                }

                // check if any job config is different from latest successful execution config
                if (checkOnly) {
                    try {
                        let count = 0;
                        Object.values(this.jobDetails).map((job) => {
                            let displayedConfig = job;
                            let executedConfig = currentJobConfigs[job.name];
                            let isConfigDifferent = this.compareConfigs(displayedConfig, executedConfig);

                            if (isConfigDifferent) count++;
                        });
                        if (count > 0) {
                            this.saveAndRunStatus = JSON.parse(JSON.stringify({
                                save_and_run_tooltip: `Your changes are not executed yet. Run the pipeline first to promote latest changes.`,
                            }));
                        }
                    } catch (error) {
                        console.error('Error checking configuration differences:', error);
                        return;
                    }
                }

                // get all the destination sandbox job configs
                const checkProdJobConfigPromises = Object.entries(this.promotions).map(async ([jobName, promotion]) => {
                    let sandbox = promotion.dst_sandbox_name;
                    let job = promotion.dst_job_name;

                    await this.readJob({ sandboxName: sandbox, jobName: job })
                        .then((response) => {
                            prodJobConfigs[jobName] = response.data || null;
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                });
                await Promise.allSettled(checkProdJobConfigPromises);

                // check if any job config is different from prod sandbox job config
                let successfulPromotions = 0;
                const compareAndPromotePromises = Object.entries(this.promotions).map(async ([jobName, promotion]) => {
                    let currentConfig = currentJobConfigs[jobName];
                    let prodConfig = prodJobConfigs[jobName];
                    let isConfigDifferent = this.compareConfigs(currentConfig, prodConfig);

                    if (checkOnly) {
                        if (isConfigDifferent) successfulPromotions++;
                    }
                    else if (isConfigDifferent) {
                        // promote the job
                        console.log("Promoting job - ", jobName);
                        totalPromotions++;
                        const promotionPayload = this.preparePromotionPayload(jobName);
                        if (!promotionPayload) {
                            throw new Error(`Failed to prepare promotion payload for job - ${jobName}`);
                        }
                        await axios.post(`${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/promotions`, promotionPayload, {
                            headers: {
                                Authorization: `Bearer ${this.$store.state.accessToken}`,
                            },
                        }).then(() => {
                            successfulPromotions++;
                        }).catch((error) => {
                            console.error(error);
                            throw new Error(`Failed to promote job - ${jobName}`);
                        });
                    }
                });
                await Promise.allSettled(compareAndPromotePromises);

                // if checkOnly is true, return promotion_required and promotion_tooltip (just for UX)
                if (checkOnly) {
                    this.promotionStatus = JSON.parse(JSON.stringify({
                        promotion_enabled: true,
                        promotion_tooltip: successfulPromotions > 0 ? `Configuration changes has not been promoted yet. Click to promote the changes!` : '',
                        promotion_tooltip_icon_class: 'fa fa-circle-exclamation text-warning',
                    }));
                    return;
                }

                if (totalPromotions === 0) {
                    this.$store.dispatch("addToast", {
                        message: `No changes detected.`,
                        type: "info",
                    });
                } else if (successfulPromotions === totalPromotions) {
                    this.$store.dispatch("addToast", {
                        message: `Promotion requests raised successfully.`,
                        type: "success",
                    });
                } else if (successfulPromotions > 0) {
                    this.$store.dispatch("addToast", {
                        message: `Promotion requests raised partially.`,
                        type: "warning",
                    });
                } else {
                    this.$store.dispatch("addToast", {
                        message: `Failed to raise promotion requests.`,
                        type: "error",
                    });
                }
            } catch (error) {
                console.error('Error promoting required jobs:', error);
                this.$store.dispatch("addToast", {
                    message: "Failed to raise promotion requests. Please contact support.",
                    type: "error",
                });
            } finally {
                this.promoting = '';
            }
        },
        compareConfigs(currentConfig, prodConfig) {
            if (!currentConfig || !prodConfig) {
                return true;
            }
            if ((currentConfig.system_files?.length !== prodConfig.system_files?.length) || (currentConfig.user_files?.length !== prodConfig.user_files?.length)) {
                return true;
            }

            if (currentConfig.system_files?.length > 0) {
                for (const systemFile of currentConfig.system_files) {
                    const prodSystemFile = prodConfig.system_files.find(file => file.relative_path === systemFile.relative_path);

                    // compare the contents of the two files
                    if (!prodSystemFile || prodSystemFile.content !== systemFile.content) {
                        return true;
                    }
                }
            }

            if (currentConfig.user_files?.length > 0) {
                for (const userFile of currentConfig.user_files) {
                    const prodUserFile = prodConfig.user_files.find(file => file.relative_path === userFile.relative_path);

                    // compare the contents of the two files
                    if (!prodUserFile || prodUserFile.content !== userFile.content) {
                        return true;
                    }
                }
            }
            return false;
        },
        setDestinationSandbox(sandbox) {
            this.destinationSandbox = sandbox;
            this.promoteRequiredJobs(true); // to trigger promotion status inspection

            // for all promotion objects, update the destination sandbox name
            Object.values(this.promotions).forEach(promotion => {
                promotion.dst_sandbox_name = sandbox;
            });
        },


        setRunAllButton(visibility) {
            this.showRunAllButton = visibility;
        },
        setEditButton(visibility) {
            this.showEditButton = visibility;
        },
        onEditClick() {
            this.editMode = true;
        },
        setEditMode(mode) {
            this.editMode = mode;
        },
        onSaveclick() {
            this.saveTrigger = !this.saveTrigger;
        },
        onSaveAndRunCLick() {
            this.saveAndRunTrigger = !this.saveAndRunTrigger;
        },
        onCancelClick() {
            this.editMode = false;
            this.jobDetails = JSON.parse(JSON.stringify(this.jobDetails)); // to reset edited data
        },
        showSaving(saving) {
            this.saving = saving;
        },
        onPromoteClick() {
            this.promoteRequiredJobs();
        },
        setPromoteButton(visibility) {
            this.showPromoteButton = visibility;
        },
        async triggerPipelineStatusCheck(executionId) {
            await this.trackPipelineExecutionStatus(executionId);
        },

        // visualization related methods
        setVisualizationButton(visibility) {
            this.showVisualizationButton = visibility;
        },
        async visualize(forceGet = false) {
            if ((!forceGet && this.outputData) || this.queryRunning) return; // if (output data is already fetched and not force get) or query is running, then return

            this.queryName = `${this.$store.state.currentClient.cid}_${this.pipelineJob?.name}_query`; // query name should be in the format of <cid>_<job_name>_query
            this.queryRunning = true;
            this.queryId = null;
            this.outputData = null;
            this.outputColumns = [];
            this.isPartialResult = false;
            this.visualizationError = null;
            try {
                // submit query
                await axios.post(`${this.$store.state.pailUrl}/${this.$store.state.pailVersion}/cids/${this.$store.state.currentClient.cid}/named_queries/${this.queryName}/execute`, null,
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.state.accessToken}`,
                        },
                    }
                ).then((response) => {
                    if (!response.data || !response.data.query_execution_id) {
                        console.error("Error getting query execution id");
                        this.visualizationError = "Failed to get query execution id. Please contact support."
                    }
                    this.queryId = response.data.query_execution_id
                }).catch((error) => {
                    this.$store.dispatch("addToast", {
                        message: "Failed to submit query. Please retry or contact support.",
                        type: "error",
                    });
                });
                if (!this.queryId) return;

                try {
                    // check query execution status
                    let counter = 50;
                    while (counter > 0 && !this.breakCheckVisualization) {
                        const response = await axios.get(this.$store.state.pailUrl + `/${this.$store.state.pailVersion}/cids/${this.$store.state.currentClient.cid}/query_status/${this.queryId}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                                },
                            }
                        )
                        if (!response.data) {
                            console.error("No response status found");
                            return;
                        }

                        // failed
                        if (response.data.State === "FAILED") {
                            console.error("Query execution failed: ", response.data.StateChangeReason);
                            this.visualizationError = "Failed to fetch query results. Please retry or contact support.";
                            return;
                        }
                        // running or queued
                        else if (response.data.State === "RUNNING" || response.data.State === "QUEUED") {
                            await new Promise(resolve => setTimeout(resolve, 5000)); // sleep for 5s
                        }
                        // completed
                        else {
                            await axios.get(this.$store.state.pailUrl + `/${this.$store.state.pailVersion}/cids/${this.$store.state.currentClient.cid}/query_executions/${this.queryId}`,
                                {
                                    headers: {
                                        Authorization: `Bearer ${this.$store.state.accessToken}`,
                                    },
                                }
                            ).then((response) => {
                                if (Object.prototype.hasOwnProperty.call(response.data, "message")) {
                                    this.visualizationError = response.data.message
                                } else {
                                    // Format output
                                    this.formatOutput(response.data.data, response.data.column_info);

                                    // If partial data is returned, then get show export option to download full data
                                    if (response.data.partial_result) {
                                        this.isPartialResult = true;
                                    }
                                }
                            });
                            return;
                        }
                    }
                    counter--;
                } catch (error) {
                    console.error("Error checking query execution status: ", error);
                    this.visualizationError = "Failed to fetch query results. Please retry or contact support.";
                    return;
                }
            } catch (error) {
                console.error("Error visializing data: ", error);
                this.$store.dispatch("addToast", {
                    message: `Something went wrong while visializing data. Please contact support.`,
                    type: "error",
                });
            } finally {
                this.queryRunning = false;
            }
        },
        formatOutput(data, columnInfo) {
            this.outputData = JSON.parse(JSON.stringify(data.map(row => {
                let formattedRow = {};
                for (let i = 0; i < columnInfo.length; i++) {
                    formattedRow[columnInfo[i].name] = row[i] || null;
                }
                return formattedRow;
            })));
            this.outputColumns = JSON.parse(JSON.stringify(columnInfo.map(column => ({
                data: column.name,
                title: column.name
            }))));
        },
    },
};
</script>

<style scoped>
.custom-btn-group {
    display: flex;
    align-items: center;
}

.btn {
    margin-right: 12px;
}
</style>
